;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.postLinkKill = (function () {
    const initialize = function () {
      $('.postLinks a.end').on('click', function (e) {
        e.preventDefault()
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.postLinkKill.initialize()
  })
}(jQuery, window))
